import { useTranslation } from 'react-i18next';
import './TournamentListSkeleton.css';

/**
 * Scheletro della lista tornei.
 *
 * Vive in un file suo, e non dentro TournamentListPage, perche' lo usa il
 * fallback di Suspense in App.tsx: importarlo dalla pagina l'avrebbe tirata
 * dentro al bundle principale, annullando il code-splitting che il fallback
 * serve a coprire. Stessa forma del gemello dell'arena.
 *
 * Al posto della riga «Caricamento tornei…» che c'era prima: un elenco che
 * arriva e' un cambio di forma, e mostrare la forma prima del contenuto e'
 * quello che toglie il salto. La frase resta, ma solo per chi legge con lo
 * schermo — a chi vede, i riquadri la dicono meglio.
 *
 * `conTestata`: la pagina, mentre carica, monta la testata VERA — con dentro il
 * tasto per aprire un torneo, che non dipende dall'elenco e non deve sparire
 * per la durata della GET. In quel caso lo scheletro copre solo cio' che manca
 * davvero, e disegnare un secondo fantasma di testata sotto quella vera
 * sarebbe una testata di troppo. Il valore predefinito e' `true` perche' il
 * fallback di Suspense in App.tsx sostituisce la pagina INTERA, testata
 * compresa.
 */
export default function TournamentListSkeleton({ conTestata = true }: { conTestata?: boolean } = {}) {
  const { t } = useTranslation();

  return (
    <div className="tournament-list-skeleton" data-testid="tournament-list-skeleton">
      <span className="tournament-sr-only" role="status">{t('tournament.loading')}</span>
      <div aria-hidden="true">
        {conTestata && <div className="tournament-skel tournament-skel-hero" />}
        <div className="tournament-skel tournament-skel-filters" />
        <div className="tournament-skel tournament-skel-card" />
        <div className="tournament-skel tournament-skel-card" />
        <div className="tournament-skel tournament-skel-card" />
      </div>
    </div>
  );
}
